var _path, _path2, _path3, _path4, _path5, _line, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSigurantaAutomataDeschisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 80,
    viewBox: "0 0 76 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.7856 80.0039L37.7167 45.9455",
    stroke: "black",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.146 28.9258L38.1632 46.4844",
    stroke: "black",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5859 32.8398L37.5859 0.00536448",
    stroke: "black",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5864 80.0039L37.5864 47.0182",
    stroke: "black",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.75 58.251C19.75 58.6652 20.0858 59.001 20.5 59.001H27.25C27.6642 59.001 28 58.6652 28 58.251C28 57.8368 27.6642 57.501 27.25 57.501H21.25V51.501C21.25 51.0868 20.9142 50.751 20.5 50.751C20.0858 50.751 19.75 51.0868 19.75 51.501V58.251ZM35.0917 42.5986L19.9697 57.7206L21.0303 58.7813L36.1524 43.6592L35.0917 42.5986Z",
    fill: "black"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 16.7071,
    y1: 40.7071,
    x2: 10.7071,
    y2: 46.7071,
    stroke: "black",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0155 40.5063L21.2308 47.5963",
    stroke: "black",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7627 35.0586L26.6467 40.5627",
    stroke: "black",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1499 36.125L25.738 31.255",
    stroke: "black",
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4697 40.5625L21.2666 46.1807",
    stroke: "black",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSigurantaAutomataDeschisa);
export default __webpack_public_path__ + "static/media/siguranta_automata_deschisa.c57d38bda388c5db52565366e02cccb2.svg";
export { ForwardRef as ReactComponent };